<template>
  <div class="w3-container devicecommands" v-if="user">
    <button @click="$router.push('home')"  class="w3-button w3-border w3-round-xxlarge">&#171;&#171;</button>  
    <br><br>
    <template v-if="devices && selecteddevice">     
          <p>
              <button @click="sendDeviceCommand({type:'RefreshInboxes'})" class="w3-button w3-block w3-border w3-round-xxlarge">Sync Inboxes</button>
          </p>
          <p>
              <button @click="sendDeviceCommand({type:'GetContacts'})" class="w3-button w3-block w3-border w3-round-xxlarge">Sync Contacts</button>
          </p>
    </template>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "DeviceCommands",
  data() {
    return {      
      msg: "Welcome to the Device Commands Page"      
    };
  },
  beforeCreated() {},
  created: function() {},
  mounted() {},
  methods: { 
    ...mapActions(["sendDeviceCommand"])
  },
  computed: {
    ...mapGetters(["user", "devices","selecteddevice"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.devicecommands {
  padding-top: 10px;
}

.devicecommands_order_lines {
  padding-top: 10px;
}

.w3-ul li {
  border-bottom: none;
}

.footer {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/DeviceCommands.vue